import React from 'react';
import { useGame } from '../context/GameContext';

export default function Notification() {
  const { notification } = useGame();
  if (!notification) return null;
  return (
    <div className={`notification notification-${notification.type}`}>
      {notification.msg}
    </div>
  );
}
